import cx from "classnames";
import { SvgIcon, LoadingIcon } from "@/components";

import styles from "./RiskIndicatorLimited.module.sass";
import { RiskIndicatorBar } from "../RiskIndicatorBar/RiskIndicatorBar";

export type RiskScoreLevel = "low" | "medium" | "high" | "unknown";

interface RiskIndicatorLimitedProps {
  isChecking?: boolean;
  value?: RiskScoreLevel | null;
  className?: string;
}

export const RiskIndicatorLimited = ({
  isChecking,
  value,
  className,
}: RiskIndicatorLimitedProps) => {
  const riskTitle = value
    ? {
        low: "Low Risk",
        medium: "Medium Risk",
        high: "High Risk",
        unknown: "N/D Risk",
      }[value]
    : "";

  const classes = cx(
    styles.risk,
    {
      [styles[`risk--${value}`]]: value && !isChecking,
      [styles["risk--checking"]]: isChecking,
    },
    className,
  );

  return (
    <div className={classes}>
      <div className={styles.inner}>
        <RiskIndicatorBar risk={isChecking ? undefined : value || "unknown"} />

        {isChecking && (
          <div className={styles.loading}>
            <LoadingIcon />
            <span>Checking</span>
          </div>
        )}

        {!!value && !isChecking && (
          <div className={styles.content}>
            <div className={styles.info}>
              <SvgIcon name="info-circle" className={styles.icon} />
              <div className={styles.tooltip}>
                <div className={styles.low}>
                  <strong>Low:</strong> No threats, safe to proceed
                </div>
                <div className={styles.medium}>
                  <strong>Medium:</strong> Potential risks, review recommended
                </div>
                <div className={styles.high}>
                  <strong>High:</strong> Critical risks, action required
                </div>
              </div>
            </div>
            <div className={styles.title}>{riskTitle}</div>
          </div>
        )}

        <div className={styles.from}>Low</div>
        <div className={styles.to}>High</div>
      </div>
    </div>
  );
};
